import berlinerRugbyClub from './1-bundesliga/nord-ost/berliner-rugby-club.png';
import bsv from './1-bundesliga/nord-ost/bsv.png';
import fcStPauli from './1-bundesliga/nord-ost/fc-st-pauli.png';
import hannover78 from './1-bundesliga/nord-ost/Hannover-78.png';
import hrc from './1-bundesliga/nord-ost/hrc.png';
import rcLeipzig from './1-bundesliga/nord-ost/rc-leipzig.png';
import rk03Berlin from './1-bundesliga/nord-ost/rk-03-berlin.png';
import scGermaniaList from './1-bundesliga/nord-ost/sc-germania-list.png';
import heidelbergerRuderklub from './1-bundesliga/sued-west/heidelberger-ruderklub.png';
import muenchenRFC from './1-bundesliga/sued-west/Muenchen-RFC.png';
import rcLuxenburg from './1-bundesliga/sued-west/RC-Luxenburg.png';
import rgHeidelberg from './1-bundesliga/sued-west/RG-Heidelberg.png';
import rsvKoln from './1-bundesliga/sued-west/rsv-koln.png';
import scFrankfurt from './1-bundesliga/sued-west/sc-frankfurt.png';
import sportclubNeuenheim from './1-bundesliga/sued-west/sportclub-neuenheim.png';
import TSVHandschuhsheim from './1-bundesliga/sued-west/TSV-handschuhsheim.png';
import rcd from './2-bundesliga/nord-ost/rcd.png';
import ruHohenNeuendorf from './2-bundesliga/nord-ost/ru-hohen-neuendorf.png';
import svRicklingen from './2-bundesliga/nord-ost/sv-ricklingen.png';
import tsvVictoriaLinden from './2-bundesliga/nord-ost/tsv-victoria-linden.png';
import htv from './2-bundesliga/sued-west/htv.png';
import rkHeusenstamm from './2-bundesliga/sued-west/rk-heusenstamm.png';
import neckarsulm from './2-bundesliga/sued-west/neckarsulm.png';
import rcUnterföhring from './2-bundesliga/sued-west/rc-unterföhring.png';
import rcrRotweil from './2-bundesliga/sued-west/rcr-rotweil.jpg';
import rcWalferdange from './2-bundesliga/sued-west/rugby-club-walferdange.png';
import stusta from './2-bundesliga/sued-west/stusta.jpg';
import vfr06 from './2-bundesliga/nord-ost/vfr-06.png';
import stuttgarterRC from './2-bundesliga/sued-west/stuttgarter-rugby-club.png';
import placeholderClub from './placeholder-club.svg';

export const teamLogosNOMap = {
  'Berliner RC': berlinerRugbyClub,
  'BSV 1892 Rugby': bsv,
  'BSV':bsv,
  'FC St. Pauli': fcStPauli,
  'Hannover 78': hannover78,
  'Hamburger Rugby-Club': hrc,
  'RC Leipzig': rcLeipzig,
  'RK 03 Berlin': rk03Berlin,
  'SC Germania List': scGermaniaList,
}
export const teamLogosSWMap = {
  'Heidelberger Ruderklub 1872': heidelbergerRuderklub,
  'Heidelberger Ruderklub': heidelbergerRuderklub,
  'München RFC': muenchenRFC,
  'Rugby Club Luxembourg': rcLuxenburg,
  'RG Heidelberg': rgHeidelberg,
  'RSV Köln': rsvKoln,
  'SC Frankfurt 1880': scFrankfurt,
  'SC Frankfurt': scFrankfurt,
  'SC Neuenheim': sportclubNeuenheim,
  'TSV Handschuhsheim': TSVHandschuhsheim
};

export const teamLogosNOMapZweiteBL = {
  'SV Ricklingen': svRicklingen,
  'Rugby Cricket Dresden': rcd,
  'TSV Victoria Linden': tsvVictoriaLinden,
  'SG Rugbyunion Hohen Neuendorf e.V.': ruHohenNeuendorf,
  'VfR 06': vfr06,
};
export const teamLogosSWMapZweiteBL = {
  'Heidelberger Turnverein': htv,
  "Heidelberger Turnverein 1846": htv,
  'RC Unterföhring': rcUnterföhring,
  'RK Heusenstamm': rkHeusenstamm,
  'Rugby-Club Rottweil': rcrRotweil,
  "Walferdange Rugby Seniors": rcWalferdange,
  // Clubee hat den Verein umbenannt; der alte Name bleibt als Alias, solange
  // gecachte Daten aus 2025/26 noch ausgeliefert werden koennen.
  'SG SV Studentenstadt Freimann / ESV München-Freimann': stusta,
  'StuSta Rugby': stusta,
  'Stuttgarter Rugby-Club': stuttgarterRC,
  'Sport-Union Neckarsulm': neckarsulm,
  'München RFC': muenchenRFC,
  'SC Frankfurt 1880': scFrankfurt,
}

export const teamLogosMap ={
    ...teamLogosNOMap,
    ...teamLogosSWMap,
    ...teamLogosNOMapZweiteBL,
    ...teamLogosSWMapZweiteBL,
}

export const teamLogosNOList = Object.values(teamLogosNOMap);
export const teamLogosSWList = Object.values(teamLogosSWMap);

export const teamLogosList = Object.values(teamLogosMap);

export const placeholderLogo = placeholderClub;

/**
 * Logo zu einem Clubee-Vereinsnamen. Faellt auf ein neutrales Platzhalter-Wappen
 * zurueck, damit ein neuer Verein kein kaputtes Bild rendert, bis sein Logo
 * nachgetragen ist.
 */
export const getTeamLogo = (clubeeName) =>
  teamLogosMap[clubeeName] || placeholderClub;